import { render } from "./FireMap.vue?vue&type=template&id=5ecb12f4"
import script from "./FireMap.vue?vue&type=script&lang=ts"
export * from "./FireMap.vue?vue&type=script&lang=ts"
script.render = render

export default script